/* eslint-disable camelcase */
import React from "react";
import { connect } from "react-redux";
import { firebase, getStudioData } from "~/src/api";
import {
  AppWithAuthentication, Head, Layout, Loading,
} from "~/src/components/global";
import { JobFormNew } from "~/src/components/jobs";

class AddJob extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      sentLoadRequest: false,
    };
  }

  loadData = async () => {
    this.setState({ sentLoadRequest: true });

    const studios = await firebase.studios().orderBy("name").get();
    const promises = studios.docs.map((studio) => getStudioData({ studio, withLocations: true }));

    this.setState({
      loading: false,
      studios: await Promise.all(promises),
    });
  }

  componentDidMount = async () => {
    if (this.props.authUser !== null && !this.state.sentLoadRequest) this.loadData();
  }

  componentDidUpdate = async () => {
    if (this.props.authUser !== null && !this.state.sentLoadRequest) this.loadData();
  }

  render() {
    const { authUser } = this.props;
    const { studios, loading } = this.state;

    const markup = loading ? (
      <Loading />
    ) : (
      <JobFormNew authUser={authUser} studios={studios} />
    );

    return (
      <AppWithAuthentication>
        <Layout size="sm">
          <Head
            title="Post Job · Bolstr"
          />

          {markup}
        </Layout>
      </AppWithAuthentication>
    );
  }
}

const mapStateToProps = (state) => ({
  authUser: state.sessionState.authUser,
});

export default connect(mapStateToProps)(AddJob);
